import * as React from 'react';
import Svg, {
  SvgProps, G, Path, Defs, ClipPath,
} from 'react-native-svg';

const EllipseIcon = (props: SvgProps) => (
  <Svg
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        stroke="#0058AD"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M6.666 13.51a5.675 5.675 0 0 1-4.175-4.176m11.018 0a5.675 5.675 0 0 1-4.176 4.175m0-11.017a5.676 5.676 0 0 1 4.176 4.175m-11.018 0a5.676 5.676 0 0 1 4.175-4.175M2.4 9.334h.533c.373 0 .56 0 .703-.073a.667.667 0 0 0 .291-.291C4 8.827 4 8.64 4 8.267v-.533c0-.373 0-.56-.073-.703a.667.667 0 0 0-.291-.291c-.143-.073-.33-.073-.703-.073H2.4c-.374 0-.56 0-.703.073a.667.667 0 0 0-.291.291c-.073.143-.073.33-.073.703v.533c0 .374 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073Zm10.666 0h.534c.373 0 .56 0 .702-.073a.666.666 0 0 0 .292-.291c.072-.143.072-.33.072-.703v-.533c0-.373 0-.56-.072-.703a.666.666 0 0 0-.292-.291c-.142-.073-.329-.073-.702-.073h-.534c-.373 0-.56 0-.702.073a.667.667 0 0 0-.292.291c-.072.143-.072.33-.072.703v.533c0 .374 0 .56.072.703a.667.667 0 0 0 .292.291c.142.073.329.073.702.073ZM7.733 4.001h.533c.374 0 .56 0 .703-.073a.667.667 0 0 0 .291-.291c.073-.143.073-.33.073-.703v-.533c0-.374 0-.56-.073-.703a.667.667 0 0 0-.291-.291c-.143-.073-.33-.073-.703-.073h-.533c-.373 0-.56 0-.703.073a.667.667 0 0 0-.291.291c-.073.143-.073.33-.073.703v.533c0 .373 0 .56.073.703a.667.667 0 0 0 .291.291c.143.073.33.073.703.073Zm0 10.666h.533c.374 0 .56 0 .703-.072a.667.667 0 0 0 .291-.292c.073-.142.073-.329.073-.702v-.534c0-.373 0-.56-.073-.702a.666.666 0 0 0-.291-.292c-.143-.072-.33-.072-.703-.072h-.533c-.373 0-.56 0-.703.072a.666.666 0 0 0-.291.292c-.073.142-.073.329-.073.702v.534c0 .373 0 .56.073.702a.667.667 0 0 0 .291.292c.143.072.33.072.703.072Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Svg>
);
export default EllipseIcon;
